import { useEffect, useRef } from 'react';
import { apiFetch } from '../lib/api';

type PushPreferencePayload = {
  push_enabled?: boolean;
};

export function usePushNotifications(isAuthenticated: boolean) {
  const shownIds = useRef<Set<number>>(new Set());

  useEffect(() => {
    if (!isAuthenticated || typeof window === 'undefined' || !('Notification' in window)) {
      return;
    }

    let intervalId: number | null = null;
    let cancelled = false;
    let enabled = false;

    const tick = async () => {
      if (cancelled || !enabled || Notification.permission !== 'granted') return;

      const response = await apiFetch('/api/notifications?only_unread=1');
      if (!response.ok) return;
      const notifications = await response.json();
      if (!Array.isArray(notifications)) return;

      for (const item of notifications) {
        const id = Number(item?.id);
        if (!id || shownIds.current.has(id)) continue;
        shownIds.current.add(id);
        new Notification(String(item?.title || 'Notification'), {
          body: String(item?.message || ''),
        });
      }
    };

    const start = async () => {
      const prefRes = await apiFetch('/api/notifications/preferences');
      if (!prefRes.ok) return;
      const pref = (await prefRes.json()) as PushPreferencePayload;
      enabled = !!pref.push_enabled;
      if (!enabled) return;

      await tick();
      intervalId = window.setInterval(tick, 20000);
    };

    start().catch(() => undefined);

    return () => {
      cancelled = true;
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [isAuthenticated]);
}
